module.exports = __webpack_public_path__ + "static/media/payFidalga.4e4c5cfc.png";